import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import errorCode from '@/utils/errorCode'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 已登录接口请求实例（我要维权等登录后业务接口）
// 传 openId: Bearer token
const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // 替换为你的API基地址
    // baseURL: '/dev-api',
    timeout: 1000 * 60 * 5, // 请求超时时间
});

// 从 sessionStorage 读取登录返回的 token
// token 在登录响应对象顶层（{code, data, token}），登录成功时单独存入 sessionStorage
function getToken() {
    try {
        const token = sessionStorage.getItem('token') || ''
        console.log('[request] getToken =>', token ? `Bearer ${token.slice(0, 25)}...` : '(空)')
        return token
    } catch (e) {
        console.warn('[request] getToken 异常:', e.message)
        return ''
    }
}

// 请求拦截器
request.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json';
        config.headers['self-system'] = 'pc';
        const token = getToken()
        if (token) {
            // 请求头名称为 openId，值使用 Bearer 格式
            config.headers['openId'] = /^Bearer\s/i.test(token) ? token : `Bearer ${token}`
        }
        return config;
    },
    error => {
        // 请求错误处理
        return Promise.reject(error);
    }
);

// 响应拦截器
request.interceptors.response.use(
    res => {
        // 未设置状态码则默认成功状态
        const code = res.data.code || 200;
        // 获取错误信息
        let msg = errorCode[code] || res.data.msg || errorCode['default']
        if (code === 401) {
            MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
            }
            ).then(() => {
                store.dispatch('LogOut').then(() => {
                    location.href = '/';
                }).catch(() => {
                    location.href = '/';

                })
            })
        } else if (code === 500) {
            Message({
                message: msg,
                type: 'error'
            })
            return Promise.reject(new Error(msg))
        } else if (code === 5001) {
            // 当前页面停留时间过长，提示后刷新页面
            let second = 5
            MessageBox.confirm('当前页面停留时间过长，请重新操作', '系统提示', {
                confirmButtonText: '刷新页面',
                showCancelButton: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                type: 'warning'
            }).then(() => {
                location.reload()
            }).catch(() => {
            })
            let timer = setInterval(() => {
                second -= 1
                if (second == 0) {
                    MessageBox.close()
                    clearInterval(timer)
                    location.reload()
                }
            }, 1000)
            return Promise.reject(new Error(msg))
        } else if (code !== 200) {
            Notification.error({
                title: msg
            })
            return Promise.reject('error')
        } else {
            return res.data
        }
    },
    error => {
        // 响应错误处理
        return Promise.reject(error);
    }
);

export default request;
